'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _antd = require('@adparlor-devops/antd');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _picasso = require('../../helpers/picasso');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionIcons = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ActionIcons, _Component);

  function ActionIcons() {
    (0, _classCallCheck3.default)(this, ActionIcons);
    return (0, _possibleConstructorReturn3.default)(this, (ActionIcons.__proto__ || (0, _getPrototypeOf2.default)(ActionIcons)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActionIcons, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.previewState === this.props.previewState) return false;

      return true;
    }
  }, {
    key: 'buildPreviewIcon',
    value: function buildPreviewIcon() {
      var _props = this.props,
          _props$previewState = _props.previewState,
          previewState = _props$previewState === undefined ? {} : _props$previewState,
          _props$onGeneratePrev = _props.onGeneratePreview,
          onGeneratePreview = _props$onGeneratePrev === undefined ? function () {} : _props$onGeneratePrev,
          _props$onViewPreview = _props.onViewPreview,
          onViewPreview = _props$onViewPreview === undefined ? function () {} : _props$onViewPreview;

      if (previewState === _picasso.PREVIEW_STATES.PREVIEW_ERROR) return _react2.default.createElement(_antd.Icon, { type: 'close-circle-o', onClick: onGeneratePreview });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_QUEUED) return _react2.default.createElement(_antd.Icon, { type: 'clock-circle-o' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_LOADING || previewState === _picasso.PREVIEW_STATES.PREVIEW_REQUESTING) return _react2.default.createElement(_antd.Icon, { type: 'loading' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_FLASH_COMPLETED) return _react2.default.createElement(_antd.Icon, { type: 'check-circle-o' });else if (previewState === _picasso.PREVIEW_STATES.PREVIEW_AVAILABLE) return _react2.default.createElement(_antd.Icon, { className: 'available', type: 'eye', onClick: onViewPreview });
      return _react2.default.createElement(_antd.Icon, { type: 'eye', onClick: onGeneratePreview });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$onDelete = _props2.onDelete,
          onDelete = _props2$onDelete === undefined ? function () {} : _props2$onDelete,
          _props2$onDuplicate = _props2.onDuplicate,
          onDuplicate = _props2$onDuplicate === undefined ? function () {} : _props2$onDuplicate,
          _props2$previewToolti = _props2.previewTooltip,
          previewTooltip = _props2$previewToolti === undefined ? "" : _props2$previewToolti;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            { onClick: onDelete },
            _react2.default.createElement(
              _antd.Tooltip,
              { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'GenerateVariations.table.operation.delete.label', defaultMessage: 'Delete' }) },
              _react2.default.createElement(_antd.Icon, { type: 'delete' })
            )
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            { onClick: onDuplicate },
            _react2.default.createElement(
              _antd.Tooltip,
              { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'GenerateVariations.table.operation.duplicate.label', defaultMessage: 'Duplicate' }) },
              _react2.default.createElement(_antd.Icon, { type: 'copy' })
            )
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            { className: 'preview-icon-container' },
            _react2.default.createElement(
              _antd.Tooltip,
              { title: previewTooltip },
              this.buildPreviewIcon()
            )
          )
        )
      );
    }
  }]);
  return ActionIcons;
}(_react.Component), _class.propTypes = {
  previewState: _propTypes2.default.string.isRequired,
  previewTooltip: _propTypes2.default.string.isRequired,
  onGeneratePreview: _propTypes2.default.func.isRequired,
  onViewPreview: _propTypes2.default.func.isRequired,
  onDelete: _propTypes2.default.func.isRequired,
  onDuplicate: _propTypes2.default.func.isRequired
}, _temp);
exports.default = ActionIcons;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/ActionIcons/index.js
// module id = 3887
// module chunks = 5 6 7 8